import React from 'react';
import { Link } from 'react-router-dom';
import { TECH_SECTIONS } from '../data/techSections';

const Logo = () => (
  <Link to="/" className="text-xl font-bold tracking-tight" style={{ fontFamily: "'Open Sans', sans-serif" }} data-testid="footer-logo">
    <span className="text-[#FF9933]">j</span><span className="text-white">and</span><span className="text-[#138808]">a</span>
    <span className="text-white">ta</span><span className="text-[#4169E1]">.</span><span className="text-white">ai</span>
  </Link>
);

const GROUPS = [
  ['Company', [['Home', '/'], ['Use Cases', '/#use-cases'], ['Request Data', '/contact']]],
  ['Data', [['Data Showcase', '/data/showcase']]],
  ['Technology', [...TECH_SECTIONS.map((s) => [s.title, `/technology/${s.slug}`])]],
];

const slug = (s) => s.replace(/[^a-z0-9]+/gi, '-').toLowerCase();

const Footer = () => (
  <footer className="border-t border-white/10 py-14" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid gap-10 grid-cols-2 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
      <div className="col-span-2 md:col-span-1">
        <Logo />
        <p className="text-xs text-white/30 mt-2">Embodied Data for Physical AI</p>
        <p className="text-xs text-white/20 font-mono mt-6">&copy; {new Date().getFullYear()} JanData.ai</p>
      </div>
      {GROUPS.map(([title, links]) => (
        <div key={title}>
          <h4 className="font-mono text-[11px] tracking-[0.2em] uppercase text-white/30 mb-4">{title}</h4>
          <ul className="space-y-2.5">
            {links.map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-sm text-white/50 hover:text-white transition-colors" data-testid={`footer-${slug(title)}-${slug(label)}`}>{label}</Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </footer>
);

export default Footer;
